module.exports = __webpack_public_path__ + "static/thumb_improve-adb3c81832f7285762dcdd97d10fe786.jpg";